import type { ModalitaSistema, ModalitaVmc } from './impianto';
import type { ProgrammaOrario, ProfiloRapido } from './programma';

/**
 * Comandi con conferma (contratto API §10.3). Ogni comando porta un `idComando`
 * generato dal client; la centralina risponde `accettato`, poi `applicato` o `fallito`.
 */
export type AzioneComando =
  | { azione: 'set_setpoint'; zonaId: string; valore: number }
  | { azione: 'set_zona_abilitata'; zonaId: string; abilitata: boolean }
  | { azione: 'set_setpoint_globale'; valore: number }
  | { azione: 'set_modalita'; modalita: ModalitaSistema }
  | { azione: 'set_sanitario'; setpoint?: number; boost?: boolean }
  | { azione: 'set_vmc'; modalita: ModalitaVmc }
  | { azione: 'applica_profilo'; profilo: ProfiloRapido }
  | { azione: 'set_programma'; zonaId: string; programma: ProgrammaOrario };

export type Comando = AzioneComando & { idComando: string };

export type EsitoComando = 'in_invio' | 'accettato' | 'applicato' | 'fallito';

export type MotivoFallimento =
  | 'centralina_irraggiungibile'
  | 'fuori_limiti'
  | 'sorgente_non_comandabile'
  | 'zona_inesistente'
  | 'timeout'
  | 'rifiutato';

export interface RispostaComando {
  idComando: string;
  esito: 'accettato' | 'applicato' | 'fallito';
  motivo?: MotivoFallimento;
}

let contatore = 0;

export function nuovoIdComando(): string {
  contatore += 1;
  return `c-${Date.now().toString(36)}-${contatore.toString(36)}`;
}

/** Timeout oltre il quale un comando non confermato è dichiarato fallito (RF-14). */
export const TIMEOUT_COMANDO_MS = 3_000;
